import { hotjar } from 'react-hotjar';
import { datadogRum } from '@datadog/browser-rum';

const HJID = process.env.REACT_APP_HJID;

// Hotjar tracking-code version the snippet is pinned to.
const HJSV = 6;

// The UAC already sent to Hotjar. Module scope rather than component state so a profile
// refetch or a remount of the caller cannot re-identify the same user.
let identifiedUac = null;

export const initialize = () => {
    if (!HJID) {
        return;
    }

    hotjar.initialize(HJID, HJSV);
};

/**
 * Labels the Hotjar session with the user's access code, so a recording can be traced
 * back to a user.
 *
 * @returns {boolean} whether the call reached Hotjar — the caller can retry if not.
 */
export const identifyUser = (uac, attributes = {}) => {
    if (!HJID || !uac || !hotjar.initialized()) {
        return false;
    }

    if (identifiedUac === uac) {
        return true;
    }

    try {
        hotjar.identify(uac, attributes);
        identifiedUac = uac;
        return true;
    } catch (error) {
        datadogRum.addError(error);
        return false;
    }
};
